import React, { useCallback, useMemo } from "react";
import { IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";
import {
  ArrowOutlineButton,
  ArrowPrimaryButton,
  OutlineButton,
  PrimaryButton,
} from "../../../components/Buttons/PrimaryButton";
import { Info, InfoOutlined } from "@mui/icons-material";
import { Typography, Tooltip} from "@mui/material";
import styles from "./Style.module.css";
import DataTables from "../../../Datatables/Datatable.table";
import Constants from "../../../config/constants";
import { removeUnderScore } from "../../../helper/Helper";
import FilterComponent from "../../../components/Filter/Filter.component";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import StatusPill from "../../../components/Status/StatusPill.component";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import useUserQueriesListHook from "./UserQueriesList.hook";


const UserQueriesList = (props) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    isSidePanel,
    handleSideToggle,
    handlePageChange,
    handleEdit,
    handleEditSidePannel,
    handleFilterDataChange,
    handleSearchValueChange,
    handleProfile,
    configFilter,
    editData,
    handleDetail,
    handleExport
  } = useUserQueriesListHook({});
 
  const editDataId = editData ? editData.id : null;

  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.user_queries);

  const renderFirstCell = useCallback((data) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>
            {`${capitalizeFirstLetter(
              data?.user?.name 
            )}`}{" "}
          </div>

          <div>{data?.phone_number || "N/A"  } </div>
        </div>
      </div>
    );
  }, []);

  const renderStatus = useCallback((status) => {
    if (status === "IN_PROGRESS") {
      return <StatusPill status={"IN PROGRESS"} color={"progress"} />;
    } else if (status === "PENDING") {
      return <StatusPill status={"PENDING"} color={"pending"} />;
    }else if (status === "RESOLVED") {
      return <StatusPill status={"RESOLVED"} color={"active"} />;
    }else if (status === "DISPOSED") {
      return <StatusPill status={"DISPOSED"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "complaint",
        label: "Complaint ID",
        sortable: false,
        render: (temp, all) => <div>{all?.ref_no || "N/A"}</div>,
      },
      {
        key: "full_name",
        label: "User Info",
        sortable: true,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },
      {
        key: "concern",
        label: "Concern",
        sortable: false,
        render: (temp, all) => (
          <div>{removeUnderScore(all?.concern)}</div>
        ),
      },
      {
        key: "createdAtText",
        label: "Date of Request",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.program}>{capitalizeFirstLetter(all?.createdAtText)}</div>
        ),
      },
     
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      },   
      {
        key: "ageing",
        label: "Aging",
        sortable: false,
        render: (temp, all) => <div>{all?.ageing}</div>,
      },
     {
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
         <Tooltip
             title={<>View Detail</>}
             aria-label="info"
             placement="right"
             className={styles.infoTip}
           >
            <IconButton
              onClick={(e) => {
                handleDetail(all);
              }}
              disableRipple="false"
              className={"tableActionBtn"}
            >
              <InfoOutlined fontSize={"small"} />
            </IconButton>
            </Tooltip>
            
          </div>
        ),
      },
    
    ],
    [
      renderFirstCell,
      renderStatus,
      handleEdit,
      handleProfile,

      handleEditSidePannel,
    ]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
      // draggable: true,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    present,
    currentPage,
  ]);

  return (
    <div>
      <ShadowBox className={styles.container}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            User Queries
          </Typography>
         
        </div>
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={configFilter}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder="Search by complaint Id"
          />
          <div>
            <br />
            <div className={styles.w100}>
              <DataTables
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default UserQueriesList;
